import { onStart } from './ts/compilerActions';

onStart();
